import React, { useEffect, useState, useMemo } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import {
  AiOutlineEye,
  AiOutlineDownload,
  AiOutlineDelete,
} from "react-icons/ai";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import { Select, Spin, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { LoadingOutlined } from "@ant-design/icons";
import { RxCross2 } from "react-icons/rx";
import { DatePicker } from "antd";
import dayjs from "dayjs"; // For handling date values
import Instance from "../../AxiosConfig"; 
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";

const AddIndividualTrainee = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [scopeOfWork, setScopeOfWork] = useState("");
  const [clientName, setClientName] = useState("");
  const [standard, setStandard] = useState("");
  const [email, setEmail] = useState("");
  const [firstSurveillanceAudit, setFirstSurveillanceAudit] = useState("");
  const [secondSurveillanceAudit, setSecondSurveillanceAudit] = useState("");
  const [firstSurveillanceStatus, setFirstSurveillanceStatus] = useState([]);
  const [secondSurveillanceStatus, setSecondSurveillanceStatus] = useState([]);
  const [firstSurveillanceNotes, setFirstSurveillanceNotes] = useState("");
  const [secondSurveillanceNotes, setSecondSurveillanceNotes] = useState("");
  const [certificationNumber, setCertificationNumber] = useState("");
  const [status, setStatus] = useState([]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [logoFile, setLogoFile] = useState(null);
  const [expiryDate, setExpiryDate] = useState("");
  const [registrationDate, setRegistrationDate] = useState("");
  const [showDeleteToast, setShowDeleteToast] = useState(false);
  const [showFileDownloadToast, setShowFileDownloadToast] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [agentData, setAgentData] = useState([]);
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [city, setCity] = useState("");
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [alternateEmailInput, setAlternateEmailInput] = useState("");
  const [alternateEmails, setAlternateEmails] = useState([]);
  const [errors, setErrors] = useState({});

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      message.error("You can only upload image files!");
      return Upload.LIST_IGNORE;
    }
    return true;
  };

  const handleChange = (info) => {
    if (info.file.status === "done" || info.file.status === "uploading") {
      const file = info.file.originFileObj;
      if (file) {
        setLogoFile(file);
        setImageUrl(URL.createObjectURL(file));
      }
    }
  };
  const uploadButton = (
    <div>
      <MdOutlineFileUpload size={28} />
      <div style={{ marginTop: 8 }}>Upload Logo</div>
    </div>
  );

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    addFiles(files);
  };
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const navigate = useNavigate();
  const fetchAgentData = async () => {
    // const token = localStorage.getItem("token");
    try {
      const response = await Instance.get(
        "/agents",
        //   {
        //   headers: {
        //     Authorization: `Bearer ${token}`,
        //   },
        // }
      );
      console.log(response);
      if (response.status == 200 || response.status == 201) {
        setAgentData(response?.data?.agents);
      }
    } catch (error) {
      console.log(error.response);
    }
  };
  useEffect(() => {
    fetchAgentData();
  }, []);

  const AgentOptions = agentData.map((agent) => ({
    label: agent.agentName,
    value: agent._id,
  }));

  const countryOptions = useMemo(() => countryList().getData(), []);

  const handleDrop = (e) => {
    e.preventDefault();
    const files = Array.from(e.dataTransfer.files);
    addFiles(files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const addFiles = (files) => {
    const newFiles = files.map((file) => ({
      name: file.name,
      size: (file.size / 1024).toFixed(1) + " Kb",
      date: new Date().toLocaleDateString(),
      file: file,
    }));
    setUploadedFiles((prev) => [...prev, ...newFiles]);
  };

  useEffect(() => {
    if (showSuccessMsg) {
      const timer = setTimeout(() => setShowSuccessMsg(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [showSuccessMsg]);

  const clearAllFields = () => {
    setCompanyName("");
    setAddress("");
    setRegistrationDate("");
    setExpiryDate("");
    setScopeOfWork("");
    setClientName("");
    setStandard("");
    setEmail("");
    setFirstSurveillanceAudit("");
    setSecondSurveillanceAudit("");
    setCertificationNumber("");
    setStatus([]);
    setSelectedAgents([]);
    setUploadedFiles([]); // clear attachments
    setLogoFile(null); // clear logo
    setAlternateEmails([]);
    setAlternateEmailInput("");
    setSelectedCountry(null);
    setPhone("");
    setCity("");
    setFirstSurveillanceStatus([]);
    setSecondSurveillanceStatus([]);
    setFirstSurveillanceNotes("");
    setSecondSurveillanceNotes("");
    setImageUrl(null);
  };
  const validateForm = () => {
    const newErrors = {};

    if (!selectedAgents || selectedAgents.length === 0)
      newErrors.selectedAgents = "Agent is required";

    if (!standard.trim()) newErrors.standard = "Standard is required";

    if (!selectedCountry) newErrors.country = "Country is required";

    if (!phone.trim()) newErrors.phone = "Phone number is required";

    if (!clientName.trim()) newErrors.clientName = "Client name is required";

    if (!email.trim()) newErrors.email = "Email is required";

    if (!registrationDate)
      newErrors.registrationDate = "Date of registration is required";

    if (!certificationNumber.trim())
      newErrors.certificationNumber = "Certification number is required";

    if (!status) newErrors.status = "Status is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      message.error("Please fill all mandatory fields");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      // Create form data
      const formData = new FormData();
      formData.append("companyName", companyName);
      formData.append("address", address);
      formData.append("dateOfRegistration", registrationDate);
      formData.append("certificationExpiryDate", expiryDate);
      formData.append("scopeOfWork", scopeOfWork);
      formData.append("clientName", clientName);
      formData.append("standard", standard);
      formData.append("email", email);
      formData.append("certificationNumber", certificationNumber);
      formData.append("status", status);
      formData.append("assignedAgent", selectedAgents);
      formData.append("country", selectedCountry.label);
      formData.append("city", city);
      formData.append("companyPhoneNumber", phone);
      alternateEmails.forEach((email) => {
        formData.append("alternateEmails", email);
      });

      if (logoFile) {
        formData.append("logo", logoFile);
      }
      // Append multiple attachments
      uploadedFiles.forEach((fileObj) => {
        formData.append("attachments", fileObj.file);
      });
console.log("===== SENDING FORM DATA =====");
    for (let [key, value] of formData.entries()) {
      if (value instanceof File) {
        console.log(key, `FILE -> ${value.name} (${value.size} bytes)`);
      } else {
        console.log(key, value);
      }
    }
    console.log("===== END =====");
    // return
      // Send API request
      const response = await Instance.post(
        "/individualCertification/create",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        setLoading(false);
        console.log("Upload success:", response.data);
        setShowSuccessMsg(true);
        clearAllFields();
      }
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {showSuccessMsg && (
        <div className="success-alert d-flex justify-content-between align-items-center">
          <span> certification details Uploaded successfully!</span>
          <span className="close-icon" onClick={() => setShowSuccessMsg(false)}>
            ×
          </span>
        </div>
      )}

      {showDeleteToast && (
        <div className="download-toast">
          <span>Certification details discarded successfully</span>
          <button
            className="toast-close-btn"
            onClick={() => setShowDeleteToast(false)}
          >
            <RxCross2 size={18} />
          </button>
        </div>
      )}
      <div className="company-form mt-4 p-4">
        <div className="details-page">
          <ImgCrop rotationSlider aspect={1} shape="round" quality={1}>
            <Upload
              name="logo"
              listType="picture-circle"
              className="avatar-uploader"
              showUploadList={false}
              beforeUpload={beforeUpload}
              customRequest={({ onSuccess }) =>
                setTimeout(() => onSuccess("ok"), 0)
              } // disable auto-upload
              onChange={handleChange}
            >
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Company Logo"
                  className="profile-img-preview"
                  draggable={false}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </ImgCrop>
        </div>
      </div>
      <div className="company-form mt-4">
        {/* Your existing form fields */}

        <div className="row ">
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Company Name </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Agent <span className="text-danger">*</span>
            </label>
            <Select
              className="custom-multi-select"
              options={AgentOptions}
              style={{ width: "100%" }}
              placeholder="select Agent"
              value={selectedAgents}
              onChange={(value) => setSelectedAgents(value)}
            />
            {errors.selectedAgents && (
              <div className="text-danger small">{errors.selectedAgents}</div>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Standard <span className="text-danger">*</span>
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Standard"
              value={standard}
              onChange={(e) => setStandard(e.target.value)}
            />
            {errors.standard && (
              <div className="text-danger small">{errors.standard}</div>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Address</label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Country <span className="text-danger">*</span>
            </label>
            <Select
              showSearch
              className="custom-multi-select"
              style={{ width: "100%" }}
              placeholder="Select Country"
              options={countryOptions.map((c) => ({
                label: c.label,
                value: c.value,
              }))}
              value={selectedCountry?.value}
              onChange={(value) => {
                const selected = countryOptions.find((c) => c.value === value);
                setSelectedCountry({
                  label: selected.label,
                  value: selected.value,
                });
              }}
              filterOption={(input, option) =>
                option.label.toLowerCase().includes(input.toLowerCase())
              }
            />
            {errors.country && (
              <div className="text-danger small">{errors.country}</div>
            )}
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Phone <span className="text-danger">*</span>
            </label>
            <PhoneInput
              defaultCountry="in"
              value={phone}
              onChange={(phone) => setPhone(phone)}
              style={{ width: "100%" }}
            />
            {errors.phone && (
              <div className="text-danger small">{errors.phone}</div>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">City </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Client Name<span className="text-danger">*</span>{" "}
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Client Name"
              value={clientName}
              onChange={(e) => setClientName(e.target.value)}
            />
            {errors.clientName && (
              <div className="text-danger small">{errors.clientName}</div>
            )}
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Email <span className="text-danger">*</span>
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && (
              <div className="text-danger small">{errors.email}</div>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">Alternate Emails</label>
            <div
              className="form-control d-flex flex-wrap align-items-center"
              style={{ minHeight: "38px" }}
            >
              {alternateEmails.map((email, index) => (
                <span
                  key={index}
                  className="badge bg-primary me-2 mb-1 d-flex align-items-center"
                  style={{ fontSize: "0.85rem" }}
                >
                  {email}
                  <button
                    type="button"
                    onClick={() =>
                      setAlternateEmails(
                        alternateEmails.filter((_, i) => i !== index),
                      )
                    }
                    className="btn-close btn-close-white ms-2"
                    style={{ fontSize: "0.6rem" }}
                  ></button>
                </span>
              ))}

              <input
                type="text"
                value={alternateEmailInput}
                onChange={(e) => setAlternateEmailInput(e.target.value)}
                onKeyDown={(e) => {
                  if (["Enter", ","].includes(e.key)) {
                    e.preventDefault();
                    const email = alternateEmailInput.trim();
                    if (email && !alternateEmails.includes(email)) {
                      setAlternateEmails([...alternateEmails, email]);
                      setAlternateEmailInput("");
                    }
                  }
                }}
                placeholder="Add alternate email and press Enter"
                style={{
                  border: "none",
                  outline: "none",
                  flex: 1,
                  minWidth: "150px",
                }}
              />
            </div>
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Date of Registration <span className="text-danger">*</span>
            </label>
            <DatePicker
              className="form-control input-placeholder"
              value={registrationDate ? dayjs(registrationDate) : null}
              onChange={(date) =>
                setRegistrationDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
            {errors.registrationDate && (
              <div className="text-danger small">{errors.registrationDate}</div>
            )}
          </div>

          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Expiry Date
            </label>

            <DatePicker
              className="form-control input-placeholder"
              value={expiryDate ? dayjs(expiryDate) : null}
              onChange={(date) =>
                setExpiryDate(date ? date.format("YYYY-MM-DD") : "")
              }
              format="YYYY-MM-DD"
            />
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Certification Number <span className="text-danger">*</span>
            </label>
            <input
              className="input-placeholder form-control"
              type="text"
              placeholder="Enter Certification Number"
              value={certificationNumber}
              onChange={(e) => setCertificationNumber(e.target.value)}
            />
            {errors.certificationNumber && (
              <div className="text-danger small">
                {errors.certificationNumber}
              </div>
            )}
          </div>
          <div className="col-lg-4 mt-2">
            <label className="input-label form-label">
              Status <span className="text-danger">*</span>
            </label>
            <Select
              // mode="multiple"
              className="custom-multi-select"
              placeholder="Enter Status"
              options={[
                { value: "Active", label: "Active" },
                { value: "Inactive", label: "Inactive" }, // fix here
              ]}
              value={status}
              onChange={(value) => setStatus(value)}
              style={{ width: "100%" }}
            />
            {errors.status && (
              <div className="text-danger small">{errors.status}</div>
            )}
          </div>
        </div>

        <div className="col-lg-12 mt-3">
          <label className="input-label form-label">Scope of Work</label>
          <textarea
            className="input-placeholder form-control"
            placeholder="Enter scope of work..."
            rows={4} // height of the textarea
            value={scopeOfWork}
            onChange={(e) => setScopeOfWork(e.target.value)}
          />
        </div>

        {/* Upload Section */}
        <div className="attachment-upload mt-4">
          <label className="input-label form-label">Attachment</label>
          <div
            className="upload-box"
            onDrop={handleDrop}
            onDragOver={handleDragOver}
          >
            <input
              id="fileInput"
              type="file"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            <p
              className="upload-text"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Drag and Drop Attachment here or{" "}
              <span className="upload-link">click to Upload</span>{" "}
              <span className="upload-icon">
                <MdOutlineFileUpload />
              </span>
            </p>
          </div>
        </div>

        {/* File Details Table */}
        {uploadedFiles.length > 0 && (
          <div className="table-responsive">
            <table className="file-table">
              <thead>
                <tr>
                  <th>File Name</th>

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {uploadedFiles.map((file, index) => (
                  <tr key={index}>
                    <td>{file.name}</td>
                    <td>{file.size}</td>
                    <td>{file.date}</td>
                    <td className="file-actions">
                      {/* 👁 View File */}
                      <AiOutlineEye
                        className="action-icon"
                        onClick={() => {
                          const fileURL = URL.createObjectURL(file.file);
                          setModalImageSrc(fileURL);
                          setShowModal(true);
                        }}
                      />

                      {/* ⬇ Download File */}
                      <AiOutlineDownload
                        className="action-icon"
                        onClick={() => {
                          setShowFileDownloadToast(true);
                          setTimeout(
                            () => setShowFileDownloadToast(false),
                            3000,
                          );

                          const url = URL.createObjectURL(file.file);
                          const link = document.createElement("a");
                          link.href = url;
                          link.download = file.name;
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                          URL.revokeObjectURL(url);
                        }}
                      />

                      {/* 🗑 Delete File (immediate) */}
                      <AiOutlineDelete
                        className="action-icon"
                        onClick={() =>
                          setUploadedFiles((prev) =>
                            prev.filter((_, i) => i !== index),
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {showFileDownloadToast && (
          <div className="download-toast">
            <span>Certification Downloaded Successfully</span>
            <button
              className="toast-close-btn"
              onClick={() => setShowFileDownloadToast(false)}
            >
              <RxCross2 size={18} />
            </button>
          </div>
        )}

        {showModal && (
          <div
            className="image-modal-overlay"
            onClick={() => setShowModal(false)}
          >
            <div
              className="image-modal-content"
              onClick={(e) => e.stopPropagation()}
            >
              {modalImageSrc?.endsWith(".pdf") ? (
                <iframe
                  src={modalImageSrc}
                  title="PDF Preview"
                  width="100%"
                  height="500px"
                />
              ) : (
                <img
                  src={modalImageSrc}
                  alt="Preview"
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              )}
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
            </div>
          </div>
        )}

        <div className="d-flex justify-content-end gap-3 mt-4">
          <button
            className="discard-btn"
            onClick={() => navigate("/individual-trainee-page")}
          >
            Discard
          </button>

          <button className="save-btn" onClick={handleSubmit}>
            {loading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "#fff" }}
                    spin
                  />
                }
              />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddIndividualTrainee;
